import React, { useState } from 'react';

import { DoorGroupDetail } from 'src/modules/designStudio/components/DesignMenu/Menu/DoorGroupMenu/DoorGroupDetail';
import { DoorGroupList } from 'src/modules/designStudio/components/DesignMenu/Menu/DoorGroupMenu/DoorGroupList';
import type { DoorCounts } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';
import { DoorGroup } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';
import { useBuildingDesigner } from 'src/modules/designStudio/helpers/machete/useBuildingDesigner';

export const DOOR_ENUM_TO_NAME: Record<DoorGroup, string> = {
  FRONT: 'Front',
  GARAGE: 'Garage',
  SERVICE: 'Service',
  SLIDING_GLASS: 'Sliding Glass',
};

export const DoorGroupMenu = ({ closeMenu }: { closeMenu: () => void }) => {
  const { buildingAppearances } = useBuildingDesigner();
  const [selectedDoorGroup, setSelectedDoorGroup] = useState<
    DoorGroup | undefined
  >(undefined);

  const doors: DoorCounts = {
    ...buildingAppearances.doorCounts,
    [DoorGroup.SLIDING_GLASS]: {
      count: 0,
    },
  };

  if (selectedDoorGroup === undefined) {
    return (
      <DoorGroupList
        closeMenu={closeMenu}
        doors={doors}
        setSelectedDoorGroup={setSelectedDoorGroup}
      />
    );
  }

  return (
    <DoorGroupDetail
      doorType={selectedDoorGroup}
      onBack={() => setSelectedDoorGroup(undefined)}
      onClose={closeMenu}
    />
  );
};
